import { Loading, ShowContextProvider, ShowControllerProps, useShowController} from 'react-admin'
import { NewsAuthor } from '../../components/domains/news/NewsAuthor'
import { NewsTitle } from '../../components/domains/news/NewsTitle'
import { NewsImgHeader } from '../../components/domains/news/NewsImgHeader'
import { NewsContent } from '../../components/domains/news/NewsContent'
import { Card, Container, Stack, styled } from '@mui/material'
import { useRouteExtract } from '../../hooks/useRouteExtract'
import { useMemo } from 'react'
import config from '../../config'
import ModifyTimeStamp from '../../components/ModifyTimeStamp'
// import NewsAttachment from '../../components/domains/news/NewsAttachment'
import NewsImages from '../../components/domains/news/NewsImages'
// import { NEWS_FIELDS } from '../../providers/localization/constant'

// const PreviewThumbnail = styled(ImageField)(() => ({
//   '& .RaImageField-image': {
//     width: '100%',
//     height: 300,
//     objectFit: 'cover',
//     objectPosition: '50% 50%',
//     borderRadius: 5,
//   },
// }))

// const PaperStyled = styled(Paper)(({ theme }) => ({
//   ...theme.typography.body2,
//   textAlign: 'center',
//   color: theme.palette.text.secondary,
//   height: 300,
//   width: '100%',
//   lineHeight: '60px',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   '& .RaImageField-image': {
//     verticalAlign: 'middle',
//   },
// }))

const StackStyled = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(4, 2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4, 10),
  },
}))

const CardPreview = styled(Card)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    borderRadius: 0,
    boxShadow: 'none',
  },
}))

const ContainerStyled = styled(Container)(({ theme }) => ({
  padding: 0,
  [theme.breakpoints.up('sm')]: {
    padding: 0,
  },
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(12, 0),
  },
}))

const langSupports = config('langSupports')

export const NewsPreview: React.FC = () => {
  const { pathSegments, queryParams } = useRouteExtract()
  const lang = queryParams['lang']
  const langActive = useMemo(() => (langSupports.includes(lang) ? lang : 'th'), [lang])
  const [resourceName, newId] = pathSegments
  const showProps: ShowControllerProps = {
    disableAuthentication: true,
    id: newId,
    resource: resourceName,
  }
  const showController = useShowController(showProps)
  const { isLoading } = showController
  // const translate = useTranslate()

  if (isLoading) return <Loading />

  return (
    <ShowContextProvider value={showController}>
      <ContainerStyled maxWidth='md'>
        <CardPreview elevation={0}>
          <NewsImgHeader source='cover.full_path' />
          <StackStyled spacing={1}>
            <ModifyTimeStamp language={langActive} />
            <NewsTitle source={`title_${langActive}`} />
            <NewsAuthor authorSource='create_by' dateSource='create_at' />
            {/* <NewsContent source={`short_description_${langActive}`} /> */}
            <NewsContent source={`description_${langActive}`} />
            {/* {record.thumbnail ? (
                    <PreviewThumbnail source='thumbnail.full_path' />
                  ) : (
                    <PaperStyled variant='outlined'>
                      <Typography variant='caption' sx={{ color: 'error.main' }}>
                        {translate(`${NEWS_FIELDS}.thumbnail.notfound`)}
                      </Typography>
                    </PaperStyled>
                  )} */}
            <NewsImages source='images' title='name' />
            {/* <NewsAttachment source='files.full_path' title='name' /> */}
          </StackStyled>
        </CardPreview>
      </ContainerStyled>
    </ShowContextProvider>
  )
}

export default NewsPreview
